import React, { useMemo } from "react";

/**
 * Shared helpers for banner effect components.
 * Import these in each individual effect file to keep them DRY.
 */

/** Deterministic per-index pseudo-random, stable across re-renders. */
export function seededRandom(i: number, n: number): number {
  const x = Math.sin(i * 9301 + n * 49297 + 233) * 10000;
  return x - Math.floor(x);
}

/** useMemo-based particle factory with seeded randomness. */
export function useParticles<T>(
  count: number,
  factory: (i: number, r: (n: number) => number) => T,
  deps: React.DependencyList
): T[] {
  return useMemo(() => {
    const out: T[] = [];
    for (let i = 0; i < count; i++) {
      out.push(factory(i, (n: number) => seededRandom(i, n)));
    }
    return out;
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}

/** Base style for full-cover pointer-events-none overlay containers. */
export const overlayBase: React.CSSProperties = {
  position: "absolute",
  inset: 0,
  pointerEvents: "none",
  overflow: "hidden",
};
